module.exports = __webpack_public_path__ + "img/9c9b2993a40c9228a5d57a48a3791847.png";